<template>
    <div>
        <section>
            <div class="row">
                <div class="col s12">
                    <strong>Justificativa para planos de trabalho repetidos</strong>
                </div>

                <div class="input-field col s12">

                    <select name="justificativa_pdt_repetido_qtd_caracteres"
                            id="justificativa_pdt_repetido_qtd_caracteres"
                            class="materialize-select"
							:disabled='bloqueio == true'
                            v-model.number="justificativa_pdt_repetido">
                        <option value="" disabled>Selecione uma opção</option>
                        <option value="500">500 caracteres</option>
                        <option value="1000">1000 caracteres</option>
                        <option value="1500">1500 caracteres</option>
                        <option value="2000">2000 caracteres</option>
                    </select>
                    <label for="justificativa_pdt_repetido_qtd_caracteres">Quantidade de Caracteres</label>
                </div>
            </div>

            <div class="row">
                <div class="col s12">
                    <template v-for='modalidade in pModalidades'>
						<h5>{{modalidade.descricao}}</h5>
						<template class="row" v-for="(item, item_i) in itens">
							<div class="row" v-if='item.modalidade == modalidade.descricao'>
								<div class="input-field col s12" :class="{'m6' : !item.removivel, 'm4' : item.removivel}">
									<input type="text"
										   name="item_pdt_descricao"
										   :id="`item_pdt_descricao_${item_i}`"
										   v-model="item.descricao"
										   :readonly='bloqueio == true'/>
									<label :for="`item_pdt_descricao_${item_i}`">Título do Item</label>
								</div>

								<!--div class="input-field col s12" :class="{'m4' : !item.removivel, 'm3' : item.removivel}">

									<select name="item_pdt_tipo_item"
											:id="`item_pdt_tipo_item_${item_i}`"
											@change.prevent="alteraTipoDoItem(item)"
											:disabled="!item.editavel"
											v-model="item.tipo_item">
										<option value="" disabled>Selecione uma opção</option>
										<option value="resposta">Resposta</option>
										<option value="arquivo">Arquivo</option>
									</select>
									<label :for="`item_pdt_tipo_item_${item_i}`">Tipo do Item</label>
								</div-->

								<div class="input-field col s12" :class="{'m6' : !item.removivel, 'm4' : item.removivel}">

									<select name="item_pdt_qtd_caracteres"
											:id="`item_pdt_qtd_caracteres_${item_i}`"
											:disabled="!item.editavel || bloqueio == true || item.tipo_item === 'arquivo'"
											class="materialize-select"
											v-model="item.quantidade_caracteres">
										<option value="" disabled>Selecione uma opção</option>
										<option value="N_a" :disabled="!item.tipo_item || item.tipo_item === 'resposta'">N/a</option>
										<option value="500">500 caracteres</option>
										<option value="1000">1000 caracteres</option>
										<option value="1500">1500 caracteres</option>
										<option value="2000">2000 caracteres</option>
									</select>
									<label :for="`item_pdt_qtd_caracteres_${item_i}`">Quantidade de Caracteres</label>
								</div>

								<div class="col m4 s12" v-if="item.removivel &&!bloqueio">
									<a class="btn-floating btn-large red waves-effect waves-light"
									   title="Excluir"
									   @click="removeItem(item_i)"><i class="material-icons left">delete</i>Excluir</a>
								</div>
							</div>
						</template>
						<div class="row">
							<div class="col s12">
								<button type="button" v-if='!bloqueio'
										class="btn waves-effect waves-light light-blue lighten-1"
										@click.prevent="adicionaNovoItem(modalidade.descricao)">
									<i class="material-icons left">add</i>
									Adicionar
								</button>
							</div>
						</div>
						<br><br>
					</template>
                </div>
            </div>
        </section>

        <div class="row">
            <div class="col s12">
                <button type="button" v-if='!bloqueio'
                        class="btn waves-effect waves-light indigo"
                        @click.prevent="salvaDados">
                    <i class="material-icons left">save</i>
                    Salvar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "plano_de_trabalho",
    inject: ['principal'],
    props: {
        pPlanoTrabalho: {
            type: Array,
            default: () => []
        },

        pJustificativaPdtRepetido: {
            type: Number,
            default: null,
        },
		
		pModalidades: {
            type: Array,
            default: () => []
        },
		bloqueio: {
			type: String,
            default: null,
		}
    },
    data() {
        return {
            itens: this.pPlanoTrabalho,
            justificativa_pdt_repetido: this.pJustificativaPdtRepetido,
		}
    },
    watch: {
        pPlanoTrabalho : {
            handler(newValue){
                this.itens = newValue ?? []
            },
            deep: true,
        },
        itens: {
            handler(newValue){
                this.$emit('update:pPlanoTrabalho', newValue)
            },
            deep: true,
        },
        pJustificativaPdtRepetido(newValue){
            this.justificativa_pdt_repetido = newValue
        },
        justificativa_pdt_repetido(newValue) {
            this.$emit('update:pJustificativaPdtRepetido', newValue)
        }
    },
    methods: {
        atualizaComponentes(){
            $('select[name=item_pdt_qtd_caracteres]').formSelect()
            $('select[name=item_pdt_tipo_item]').formSelect()
            M.updateTextFields()
        },

        adicionaNovoItem(modalidade){
            this.itens.push({
                id : this.itens[this.itens.length - 1].id + 1,
                ordem: this.itens[this.itens.length - 1].ordem + 1,
                descricao : null,
                tipo_item : 'resposta', //resposta ou arquivo.
                quantidade_caracteres : null,
                editavel : true,
                removivel : true,
                removido : false,
                resposta: null,
                anexo_id: null,
				modalidade: modalidade
            })
        },
        removeItem(item_i){
            Swal.fire({
                title: 'Você tem certeza que deseja excluir esse item?',
                text: "Não será possível reverter a exclusão!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, pode excluir!',
                cancelButtonText: 'Não.'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.itens.splice(item_i, 1)
                }
            })

        },
        alteraTipoDoItem(item){
            if(item.tipo_item === 'arquivo')
                item.quantidade_caracteres = 'N_a'
            else if(item.quantidade_caracteres === 'N_a')
                item.quantidade_caracteres = null
        },

        salvaDados(){
			var itens = this.itens,
				i = itens.length;
			
			while (--i >= 0) 
				if (!itens[i].descricao || !itens[i].quantidade_caracteres) { 
					Swal.fire({ title: 'Ação inválida!', text: 'É necessário informar os títulos e qtde. de caracteres de todos os ítens do plano de trabalho!', icon: 'error'})
					return ;
				}
			
            this.principal.salva();
        },
    },
    mounted() {
        this.atualizaComponentes()
    },
    updated() {
        this.atualizaComponentes()
    }
}
</script>

<style scoped>

</style>
